import React, {useState, useEffect} from 'react'
import Link from 'next/link'
import styled from "styled-components";
import Nav from './layout/nav'
import Footer from './layout/footer'


const Main = styled.main`
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  

`

const Content = styled.div`
  flex: 1 1 auto;
`

export default ({children})=> (

    <Main>
        <Nav/>
        <Content>
            {children}

        </Content>
        <Footer/>
    </Main>
)
